/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProjectSettingsServiceDeskTicketTypesField from '@jira/spa-apps__project-settings-service-desk-ticket-type-fields/src/ServiceDeskTicketTypeFieldsPage.tsx';
import { HelpCenterSettingsRedirect } from '@jira/servicedesk__customer-service-common/src/HelpCenterSettingsRedirect.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskTicketTypeFields: LazyComponent<
	() => React.JSX.Element
> = lazyForPaint<typeof ProjectSettingsServiceDeskTicketTypesField>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-service-desk-ticket-type-fields", jiraSpaEntry: "async-project-settings-service-desk-ticket-type-fields" */ '@jira/spa-apps__project-settings-service-desk-ticket-type-fields/src/ProjectSettingsServiceDeskTicketTypeFields.tsx'
		),
);

const AsyncProjectSettingsServiceDeskTicketTypeFields = (): React.JSX.Element => (
	<HelpCenterSettingsRedirect page="ticket-type-fields">
		<LazyPage
			Page={LazyProjectSettingsServiceDeskTicketTypeFields}
			pageId="project-settings-ticket-type-fields"
			shouldShowSpinner
		/>
	</HelpCenterSettingsRedirect>
);

export default AsyncProjectSettingsServiceDeskTicketTypeFields;
